module.exports = __webpack_public_path__ + "img/MURALE_FLAT.b059805d.jpg";